<div class="input-group" id="input-group-{{id}}">
    <input class="form-control w-100" id="input-{{id}}" placeholder="{{placeholder}}" (keydown)="catchKeydown($event)"
        [(ngModel)]="amountText" [disabled]="disabled" (ngModelChange)="changeValue()"
        [ngClass]="{'border-red' : isError, 'otp-number': isTextAlignCenter}" />
    <span class="input-unit" *ngIf="unit">{{unit}}</span>
</div>